import React from 'react'
import SearchPicker from '../common/SearchPicker'

const WeightPicker = (props) => {

    const { state } = props

    const option = (weight) => <span>{`${weight.name}`}</span>

    return (
        <SearchPicker
            {...props}
            value={state ? `${state?.name}` : ""}
            option={(weight) => option(weight)}
        />
    )
}

export default WeightPicker